import l from "./index615.js";
import o from "./index616.js";
import { withInstall as t, withNoopInstall as m } from "./index604.js";
const e = t(l, {
  CollapseItem: o
}), i = m(o);
export {
  e as ElCollapse,
  i as ElCollapseItem,
  e as default
};
